import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { button as buttonStyles } from './styles/button.js';
import { Size } from './enums/size.js';
import { Variant } from './enums/variant.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { Large, ...ButtonLinkSize } = Size;
export { ButtonLinkSize, Variant as ButtonLinkVariant };
let ViedocButtonLink = class ViedocButtonLink extends LitElement {
    constructor() {
        super(...arguments);
        this.size = ButtonLinkSize.Medium;
        this.variant = Variant.Neutral;
    }
    render() {
        const classNames = classMap({
            button: true,
            [`button--${this.size}`]: true,
            [`button--${this.variant}`]: true,
        });
        return html `
      <a
        class=${classNames}
        download=${ifDefined(this.download)}
        href=${ifDefined(this.href)}
        target=${ifDefined(this.target)}
      >
        <span class="button__prefix"><slot name="prefix"></slot></span>
        <span class="button__label">
          <slot></slot>
        </span>
        <span class="button__suffix"><slot name="suffix"></slot></span>
      </a>
    `;
    }
};
ViedocButtonLink.styles = [buttonStyles];
__decorate([
    property({ type: String })
], ViedocButtonLink.prototype, "download", void 0);
__decorate([
    property({ type: String })
], ViedocButtonLink.prototype, "href", void 0);
__decorate([
    property({ type: String })
], ViedocButtonLink.prototype, "target", void 0);
__decorate([
    property({ type: String })
], ViedocButtonLink.prototype, "size", void 0);
__decorate([
    property({ type: String })
], ViedocButtonLink.prototype, "variant", void 0);
ViedocButtonLink = __decorate([
    customElement('viedoc-button-link')
], ViedocButtonLink);
export { ViedocButtonLink };
